import { render } from "./BaseMultiSelectBox.vue?vue&type=template&id=5566e389&scoped=true"
import script from "./BaseMultiSelectBox.vue?vue&type=script&lang=js"
export * from "./BaseMultiSelectBox.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./BaseMultiSelectBox.vue?vue&type=style&index=1&id=5566e389&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5566e389"]])

export default __exports__